import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 37 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "18.5",
      cy: "18.5",
      r: "18.5",
      fill: "#115673"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.9516 15.7922C15.9516 15.4722 16.2076 15.2162 16.5276 15.2162H20.5596C20.8796 15.2162 21.1356 15.4722 21.1356 15.7922V29.4242C21.1356 29.7442 20.8796 30.0002 20.5596 30.0002H16.5276C16.2076 30.0002 15.9516 29.7442 15.9516 29.4242V15.7922ZM18.5436 11.9202C16.9116 11.9202 15.5996 10.6082 15.5996 8.97623C15.5996 7.34423 16.9116 6.03223 18.5436 6.03223C20.1756 6.03223 21.4876 7.34423 21.4876 8.97623C21.4876 10.6082 20.1756 11.9202 18.5436 11.9202Z",
      fill: "#EFE05F"
    }, null, -1)
  ])))
}
export default { render: render }